module.exports = __webpack_public_path__ + "static/media/ltc-new.dc64f79d.jpg";